<template>
  <div class="py-6">
    <form @submit.prevent ref="form" class="space-y-6">
      <div class="rounded-2xl border border-gray-200 bg-white p-6 space-y-4">
        <h2 class="text-lg font-semibold text-gray-800">
          Informations sur la boisson
        </h2>

        <!-- Nom et Prix -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Nom
            </label>
            <input
              required
              type="text"
              v-model="drink.name"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs"
              placeholder="Ex: Eau minérale"
            />
          </div>

          <div>
            <label class="mb-1.5 block text-sm font-medium text-gray-700">
              Prix (FCFA)
            </label>
            <input
              required
              type="number"
              min="0"
              v-model.number="drink.price"
              class="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 shadow-theme-xs"
              placeholder="Ex: 500"
            />
          </div>
        </div>

        <!-- Image -->
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700">
            Image
          </label>
          <FileUploader
            placeHolder="Choisir une image pour la boisson"
            :acceptedFilesTypes="['image/*']"
            @onFileChangedV2="handleImageUpload"
            :fileId="drink.image"
          />
          <div v-if="drink.image" class="mt-3">
            <img
              :src="drink.image"
              alt="Preview"
              class="h-20 w-20 object-contain rounded-lg border"
            />
          </div>
        </div>
      </div>

      <button class="hidden"></button>
    </form>

    <!-- Bouton d'enregistrement -->
    <div class="flex justify-end !mt-12">
      <button type="button" @click="startSave" class="buttonComponent w-full">
        Enregistrer la boisson
      </button>
    </div>

    <!-- ActionTrigger -->
    <ActionTrigger
      dataKey="saveDrink"
      ref="saveDrink"
      @success="() => $emit('saved')"
      @failed="
        err => {
          Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
            title: 'Échec d\'enregistrement',
            body: err.result?.message || 'Erreur inconnue',
          })
        }
      "
    />
  </div>
</template>

<script setup>
import { reactive, ref, watch } from 'vue'
import ActionTrigger from '@/features/data/presentation/components/ActionTrigger.vue'
import Events from '@/events/events'
import { EVENTS } from '@/shared/constants/commons'
import FileUploader from '@/presentation/components/input/FileUploader.vue'

const props = defineProps({
  drinkData: { type: Object, default: () => ({}) },
})

const saveDrink = ref(null)
const form = ref(null)

const drink = reactive({
  id: null,
  name: '',
  price: 0,
  image: '',
})

watch(
  () => props.drinkData,
  val => {
    if (val && Object.keys(val).length) {
      Object.assign(drink, val)
    }
  },
  { immediate: true },
)

function startSave() {
  const isValid = form.value.checkValidity()
  if (!isValid) {
    form.value.reportValidity()
    return
  }
  saveItem()
}

function handleImageUpload(fileData) {
  drink.image = fileData.url
}

function saveItem() {
  saveDrink.value.trigger({
    id: drink.id,
    name: drink.name,
    price: drink.price,
    image: drink.image,
  })
}
</script>

<style scoped>
img {
  transition: transform 0.2s ease-in-out;
}
img:hover {
  transform: scale(1.05);
}
</style>
